import { H5, Image, LI } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service";
import UseOutsideDropdown from "../../../../utils/UseOutsideDropdown";
import UserProfileIcons from "./UserProfileIcons";

const UserProfile = () => {
  const { ref, isComponentVisible, setIsComponentVisible } = UseOutsideDropdown(false);

  return (
    <LI className="profile-dropdown custom-dropdown">
      <div ref={ref} className="d-flex align-items-center" onClick={() => setIsComponentVisible(!isComponentVisible)}>
        <Image src={dynamicImage("profile.png")} alt="avatar" />
        <div className="flex-grow-1">
          <H5>Wade Warren</H5>
          <span>UI Designer</span>
        </div>
      </div>
      <div className={`custom-menu overflow-hidden ${isComponentVisible ? "show" : ""}`}>
        <UserProfileIcons />
      </div>
    </LI>
  );
};

export default UserProfile;
